interface BuildShareUrlProps {
	host: string
	language: string
	listingIds: string[]
	message?: string
	referral?: string
}

export const buildShareUrl = ({ host, language, listingIds, message, referral }: BuildShareUrlProps): string => {
	const url = new URL(`https://${host}/${language}/inventory/porsche/selection`)
	for (const listingId of listingIds) {
		url.searchParams.append("id", listingId)
	}
	if (referral) {
		url.searchParams.append("referral", referral)
	}
	if (message) {
		url.searchParams.append("m", message)
	}
	url.searchParams.append("int_id", "dealer_share_vehicles_link")
	return url.toString()
}
